module.exports = __webpack_public_path__ + "static/media/old-experience.e6903df7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/kudos/old-experience.png
// module id = 35
// module chunks = 0